// UpdateBanner.jsx — shows a top banner when a new SW version is waiting.
// User clicks "تحديث الآن" → SW skipWaiting → controllerchange → page reloads.
import React, { useEffect, useState } from "react";
import { activateWaitingWorker } from "./lib/pwa";
import { zVar } from "./lib/zIndex";

export default function UpdateBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handler = () => setShow(true);
    window.addEventListener("thawany:sw-update-ready", handler);
    return () => window.removeEventListener("thawany:sw-update-ready", handler);
  }, []);

  if (!show) return null;

  return (
    <div
      data-testid="update-banner"
      style={{
        position: "fixed", top: 0, insetInlineStart: 0, insetInlineEnd: 0, zIndex: zVar('extra_9999'),
        background: "linear-gradient(90deg, #16a34a 0%, #15803d 100%)",
        color: "#fff", padding: "10px 16px", boxShadow: "0 2px 12px rgba(22,163,74,.35)",
        display: "flex", alignItems: "center", justifyContent: "center", gap: 12, fontFamily: "var(--f-n)",
      }}
    >
      <span style={{ fontSize: 14, fontWeight: 700 }}>🚀 يوجد تحديث جديد للتطبيق</span>
      <button
        data-testid="update-banner-apply"
        onClick={() => {
          setShow(false);
          activateWaitingWorker();
        }}
        style={{
          padding: "6px 16px", borderRadius: 6, border: "none", cursor: "pointer",
          background: "#fff", color: "#15803d", fontWeight: 800, fontSize: 13, fontFamily: "var(--f-n)",
        }}
      >تحديث الآن ↻</button>
      <button
        data-testid="update-banner-dismiss"
        onClick={() => setShow(false)}
        aria-label="إغلاق"
        style={{ background: "transparent", color: "#fff", border: "none", cursor: "pointer", fontSize: 18, padding: "0 4px" }}
      >×</button>
    </div>
  );
}
